import Vue from  'vue'

// eslint-disable-next-line
export const noValue = value => {
  if (!value) return '-'

  return value
}

Vue.filter('NoValue', noValue)